// src/reducers/payrollReducer.js

import { 
  CREATE_PAYROLL, 
  FETCH_PAYROLLS, 
  FETCH_PAYROLL, 
  UPDATE_PAYROLL, 
  FETCH_PAYROLL_SUMMARY,
  BULK_CREATE_PAYROLL,
  PROCESS_PAYROLL,
  DELETE_PAYROLL
} from "../actions/constants";

const initialState = {
  payrolls: [],
  payroll: null,
  summary: {},
  loading: false,
  pagination: null
};

const payrolls = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PAYROLL:
      return { 
        ...state, 
        payrolls: Array.isArray(state.payrolls) ? [...state.payrolls, action.payload.payroll || action.payload] : [action.payload.payroll || action.payload]
      };
    
    case FETCH_PAYROLLS:
      return { 
        ...state, 
        payrolls: action.payload.payrolls || action.payload,
        pagination: action.payload.pagination || null
      };
    
    case FETCH_PAYROLL:
      return { ...state, payroll: action.payload };
    
    case UPDATE_PAYROLL:
      return { 
        ...state, 
        payrolls: Array.isArray(state.payrolls) ? state.payrolls.map((payroll) => 
          payroll._id === action.payload._id ? action.payload : payroll
        ) : [],
        payroll: state.payroll?._id === action.payload._id ? action.payload : state.payroll
      };
    
    case FETCH_PAYROLL_SUMMARY:
      return {
        ...state,
        summary: action.payload
      };
    
    case BULK_CREATE_PAYROLL:
      return {
        ...state,
        payrolls: Array.isArray(state.payrolls) ? [...state.payrolls, ...action.payload.results.map(r => r.payroll)] : action.payload.results.map(r => r.payroll)
      };
    
    case PROCESS_PAYROLL:
      return {
        ...state,
        payrolls: Array.isArray(state.payrolls) ? state.payrolls.map((payroll) => 
          payroll._id === action.payload._id ? action.payload : payroll
        ) : [],
        payroll: state.payroll?._id === action.payload._id ? action.payload : state.payroll
      };
    
    case DELETE_PAYROLL:
      return {
        ...state,
        payrolls: Array.isArray(state.payrolls) ? state.payrolls.filter((payroll) => payroll._id !== action.payload) : [],
        payroll: state.payroll?._id === action.payload ? null : state.payroll
      };
    
    default:
      return state;
  }
};

export default payrolls;
